/* Dr. Schrock's — Cart drawer wiring
   Intercepts the header cart button + any product-form add-to-cart and opens Dawn's <cart-drawer>.
*/
(function() {
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      // Fallback if Dawn's custom element isn't ready
      drawer.classList.add('active');
      drawer.removeAttribute('hidden');
    }
  }

  function closeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      drawer.classList.remove('active');
      setTimeout(function() { drawer.setAttribute('hidden', ''); }, 280);
    }
  }

  // 1) Header cart toggle button
  document.addEventListener('click', function(e) {
    var t = e.target.closest('[data-cart-drawer-toggle]');
    if (!t) return;
    e.preventDefault();
    openDrawer();
  });

  // 2) Drawer close button (the in-drawer × button)
  document.addEventListener('click', function(e) {
    var t = e.target.closest('[data-drawer-close]');
    if (!t) return;
    closeDrawer();
  });

  // 2b) Global Escape — close the drawer regardless of where focus is.
  //     (Dawn's built-in listener fires only when focus is INSIDE <cart-drawer>;
  //      after clicking the trigger, focus may still be on the header button,
  //      so the keyup never bubbles to the drawer element.)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.hidden && drawer.classList.contains('active')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // 3) Add-to-cart form interception (any <form action="/cart/add" ...>)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\?.*)?$/.test(action)) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function() {
        // Re-render the cart drawer + header bubble via Section Rendering API
        return fetch('/?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var drawerHTML = sections['cart-drawer'];
        var bubbleHTML = sections['cart-icon-bubble'];
        if (drawerHTML) {
          var newDrawer = new DOMParser().parseFromString(drawerHTML, 'text/html').querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
        }
        if (bubbleHTML) {
          var oldBubble = document.querySelector('cart-icon-bubble') || document.querySelector('[data-cart-count]');
          if (oldBubble) {
            var newBubble = new DOMParser().parseFromString(bubbleHTML, 'text/html').body.firstElementChild;
            if (newBubble) oldBubble.replaceWith(newBubble);
          }
        }
        openDrawer();
      })
      .catch(function(err) { console.warn('[dr-cart] add failed', err); });
  });

  // 4) /cart page progress-bar + summary live update.
  //    When a quantity input changes, re-fetch the dr-cart-progress + dr-cart-summary
  //    sections and swap them in (debounced so a fast clicker doesn't fire 5 requests).
  function updateCartPageProgress() {
    if (!document.querySelector('.dr-cart-progress-section')) return; // only on /cart
    fetch('/cart?sections=dr-cart-progress,dr-cart-summary')
      .then(function(r) { return r.json(); })
      .then(function(s) {
        if (s['dr-cart-progress']) {
          var newProg = new DOMParser().parseFromString(s['dr-cart-progress'], 'text/html').querySelector('.dr-cart-progress-section');
          var oldProg = document.querySelector('.dr-cart-progress-section');
          if (newProg && oldProg) oldProg.replaceWith(newProg);
        }
        if (s['dr-cart-summary']) {
          var newSum = new DOMParser().parseFromString(s['dr-cart-summary'], 'text/html').querySelector('.dr-cart-summary');
          var oldSum = document.querySelector('.dr-cart-summary');
          if (newSum && oldSum) oldSum.replaceWith(newSum);
        }
      })
      .catch(function() { /* silent — Dawn's own cart.js handles the user-facing update */ });
  }
  document.addEventListener('change', function(e) {
    if (!e.target.matches('input[name="updates[]"]')) return;
    clearTimeout(window.__drCartProgTimer);
    window.__drCartProgTimer = setTimeout(updateCartPageProgress, 200);
  });

  // 5) DRAWER quantity-update full pipeline.
  //    Dawn's CartDrawerItems.updateQuantity has been silently failing on this
  //    custom markup; we run our own end-to-end pipeline: POST /cart/change.js
  //    → on success → fetch fresh drawer section → swap panel innerHTML.
  function drawerLineUpdate(line, quantity) {
    var body = JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: '/' });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function(state) {
        var sections = state.sections || {};

        // Swap drawer panel innerHTML with fresh markup
        if (sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newInner = doc.querySelector('.drawer__inner');
          var liveInner = document.querySelector('cart-drawer .drawer__inner');
          if (newInner && liveInner) liveInner.innerHTML = newInner.innerHTML;
        }

        // Swap header cart bubble
        if (sections['cart-icon-bubble']) {
          var newBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').body.firstElementChild;
          var oldBubble = document.querySelector('cart-icon-bubble') || document.querySelector('[data-cart-count]');
          if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
        }
        return state;
      })
      .catch(function(err) { console.warn('[dr-cart] drawer update failed', err); });
  }

  // Click handlers on the drawer's qty +/− buttons (capture before Dawn's quantity-input handler so we can intercept)
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.matches('input[name="updates[]"]')) return;
    // Only handle changes that originated INSIDE the drawer (the /cart page lets Dawn handle it)
    if (!input.closest('cart-drawer')) return;
    var line = parseInt(input.dataset.index, 10);
    var qty  = parseInt(input.value, 10);
    if (isNaN(line) || isNaN(qty)) return;
    drawerLineUpdate(line, qty);
  });

  // Click handler for the remove × inside the drawer (we already render <cart-remove-button>
  // which has its own handler in Dawn cart.js, but if that fails silently too, this is the fallback).
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('cart-drawer .dr-cart-row__remove-btn');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-cart-row]');
    if (!row) return;
    var input = row.querySelector('input[name="updates[]"]');
    if (!input) return;
    var line = parseInt(input.dataset.index, 10);
    if (isNaN(line)) return;
    drawerLineUpdate(line, 0);
  });
})();
